import request from '@/utils/request';

export function sendMail(data) {
  return request({
    url: '/emails/send',
    method: 'post',
    data: data,
  });
}
